import {
    takeLatest,
    select,
    put
} from 'redux-saga/effects';

import {
    IS_PLASTIC_FIELD,
    newItemIsPlastic
} from '../item/newItemForm';
import { changeValue } from '../item/newItemFormModule';

import {
    CARD_TYPE,
    SWITCH_CARD_TYPE,
    completeCardTypeSwitch
} from './cardTypeModule';


export function* switchCardTypeSaga({ newType }) {
    const isPlastic = newType === CARD_TYPE.PHYSICAL;
    const prevIsPlastic = yield select(newItemIsPlastic);

    if (isPlastic === prevIsPlastic) {
        yield put(completeCardTypeSwitch());
        return;
    }

    yield put(changeValue(IS_PLASTIC_FIELD, isPlastic));

    

    yield put(completeCardTypeSwitch());
}

export function* watchSwitchCardType() {
    yield takeLatest(SWITCH_CARD_TYPE, switchCardTypeSaga);
}
